import { render, staticRenderFns } from "./OmieHistory.vue?vue&type=template&id=333d2a1c&scoped=true"
import script from "./OmieHistory.vue?vue&type=script&lang=js"
export * from "./OmieHistory.vue?vue&type=script&lang=js"
import style0 from "./OmieHistory.vue?vue&type=style&index=0&id=333d2a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333d2a1c",
  null
  
)

export default component.exports